import React, { useCallback, useState, useEffect, ChangeEvent } from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';

import { FiCamera } from 'react-icons/fi';
import { FaRegTrashAlt } from 'react-icons/fa';
import no_image from '../../../../../../../../../assets/no_image.png';
import InputLogged from '../../../../../../../../../components/InputLogged';
import Select from '../../../../../../../../../components/Select';
import api from '../../../../../../../../../services/api';

import { useToast } from '../../../../../../../../../hooks/toast';
import { useRegisterAdded } from '../../../../../../../../../hooks/registerAdded';

import {
  TabWrapper,
  AddButton,
  ButtonAction,
  FormWrapper,
  NewImg,
  LabelWrapper,
  TrashBtnWrapper,
  QtdItemContainer,
} from '../../../../../drawer_styles';
import {
  SubmitButtonWrapper,
  ModalWrapper,
  StatusSaleButton,
} from '../../../../../../styles';

import material_styles from '../../../../../drawer_styles/material_styles';

interface EditItensComplementosProps {
  id_complemento: number;
}

interface OptionType {
  id: string;
  value: string;
  label: string;
}

interface ItemComplementoType {
  descricao: string;
  preco: number;
  isNew: boolean;
  id?: number;
  produto_id?: number;
  codigo_complemento?: string;
  imagem?: string;
  newItemImage?: File;
  materiaPrimaSelected?: OptionType;
  modalOpen: boolean;
  qtd_min: number;
  qtd_max: number;
  pausar_venda?: boolean;
  ordem: number;
}

interface QtdComplementos {
  index: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

const Complementos: React.FC<EditItensComplementosProps> = ({
  id_complemento,
}) => {
  const [btnDisable, setBtnDisable] = useState(false);
  const [qtdComplementos, setQtdComplementos] = useState<QtdComplementos[]>([]);
  const [materiasPrimas, setMateriasPrimas] = useState<OptionType[]>([]);

  const [itensDoMesmoComplemento, setItensDoMesmoComplemento] = useState<
    ItemComplementoType[]
  >([]);

  const { addToast } = useToast();
  const {
    handleSetComplementoUpdated,
    handleSetComplementoDrawerClosed,
  } = useRegisterAdded();

  const classes = material_styles();
  const modalClasses = useStyles();

  useEffect(() => {
    async function loadData(): Promise<void> {
      // MateriaPrima
      const responseMateriasPrima = await api.get(`/produto/tipo/${2}`);

      const optionItems: OptionType[] = [];

      responseMateriasPrima.data.map((item: any) => {
        const option = {
          id: item.id,
          value: item.id,
          label: item.descricao,
        };

        optionItems.push(option);
      });

      setMateriasPrimas([...optionItems]);

      // Itens Complemento
      const itensFinded: ItemComplementoType[] = [];
      const qtdItens: QtdComplementos[] = [];

      const responseItens = await api.post(
        `/complemento/item/${id_complemento}`,
      );

      for (let i = 0; i < responseItens.data.length; i += 1) {
        itensFinded.push({
          ...responseItens.data[i],
          isNew: false,
          modalOpen: false,
        });
        qtdItens.push({ index: i });

        for (let z = 0; z < responseMateriasPrima.data.length; z += 1) {
          const { produto_id } = responseItens.data[i];
          const { id, descricao } = responseMateriasPrima.data[z];

          if (!!produto_id && produto_id == id) {
            itensFinded[i].materiaPrimaSelected = {
              id,
              value: id,
              label: descricao,
            };

            break;
          }
        }
      }

      setItensDoMesmoComplemento([...itensFinded]);
      setQtdComplementos([...qtdItens]);
    }

    loadData();
  }, []);

  const handleToggleModal = useCallback(
    (index: number, value: boolean) => {
      const itensComplemento = [...itensDoMesmoComplemento];
      itensComplemento[index].modalOpen = value;

      setItensDoMesmoComplemento([...itensComplemento]);
    },
    [itensDoMesmoComplemento],
  );

  const handleInputChange = useCallback(
    (
      e: ChangeEvent<HTMLInputElement>,
      item_index: number,
      input_name: string,
    ) => {
      const newStateItens = [...itensDoMesmoComplemento];

      switch (input_name) {
        case 'descricao':
          newStateItens[item_index].descricao = e.target.value;
          setItensDoMesmoComplemento([...newStateItens]);

          return;
        case 'preco':
          newStateItens[item_index].preco = Number(e.target.value);
          setItensDoMesmoComplemento([...newStateItens]);

          return;
        case 'codigo_complemento':
          newStateItens[item_index].codigo_complemento = e.target.value;
          setItensDoMesmoComplemento([...newStateItens]);
      }
    },
    [itensDoMesmoComplemento],
  );

  const handleImgChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>, item_index: number) => {
      if (e.target.files) {
        const newStateItens = [...itensDoMesmoComplemento];

        if (!newStateItens[item_index].isNew) {
          const data = new FormData();
          data.append('item_complemento_img', e.target.files[0]);

          const response = await api.patch(
            `/complemento/item/${newStateItens[item_index].id}`,
            data,
          );

          addToast({
            type: 'success',
            title: 'Imagem do complemento atualizada',
          });

          newStateItens[item_index].imagem = response.data.imagem;
          setItensDoMesmoComplemento([...newStateItens]);
        } else {
          newStateItens[item_index].newItemImage = e.target.files[0];
          setItensDoMesmoComplemento([...newStateItens]);
        }
      }
    },
    [itensDoMesmoComplemento, addToast],
  );

  const handleSetQtd = useCallback(
    (input: string, operacao: string, index: number) => {
      const newQtdItem = [...itensDoMesmoComplemento];

      if (operacao === 'increment') {
        input === 'qtdMin'
          ? (newQtdItem[index].qtd_min = newQtdItem[index].qtd_min + 1)
          : (newQtdItem[index].qtd_max = newQtdItem[index].qtd_max + 1);
      } else if (operacao === 'decrement') {
        if (input === 'qtdMin') {
          if (newQtdItem[index].qtd_min - 1 < 0) return;

          newQtdItem[index].qtd_min = newQtdItem[index].qtd_min - 1;
        }

        if (input === 'qtdMax') {
          if (newQtdItem[index].qtd_max - 1 < 0) return;

          newQtdItem[index].qtd_max = newQtdItem[index].qtd_max - 1;
        }
      }

      setItensDoMesmoComplemento([...newQtdItem]);
    },
    [itensDoMesmoComplemento],
  );

  const handleChangeMateriaPrima = useCallback(
    (index: number, data: any) => {
      const itensComplemento = [...itensDoMesmoComplemento];

      itensComplemento[index].materiaPrimaSelected = { ...data };
      setItensDoMesmoComplemento([...itensComplemento]);
    },
    [itensDoMesmoComplemento],
  );

  const handleActiveChange = useCallback(
    async (value: boolean, index: number) => {
      try {
        const newItens = [...itensDoMesmoComplemento];

        const { id } = itensDoMesmoComplemento[index];

        setItensDoMesmoComplemento(
          newItens.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                pausar_venda: !value,
              };
            }

            return item;
          }),
        );
      } catch (err) {
        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });
      }
    },
    [itensDoMesmoComplemento, addToast],
  );

  const handleAddComplemento = useCallback(() => {
    setItensDoMesmoComplemento([
      ...itensDoMesmoComplemento,
      {
        descricao: '',
        preco: 0,
        isNew: true,
        modalOpen: false,
        qtd_min: 0,
        qtd_max: 0,
        ordem: itensDoMesmoComplemento.length,
      },
    ]);

    setQtdComplementos([
      ...qtdComplementos,
      { index: qtdComplementos[qtdComplementos.length - 1].index + 1 },
    ]);
  }, [itensDoMesmoComplemento, qtdComplementos]);

  const handleSubmit = useCallback(async () => {
    try {
      const requestArray: any[] = [];
      const dataForm = new FormData();
      let hasError = false;

      itensDoMesmoComplemento.map(async (item) => {
        if (!item.descricao) {
          addToast({
            type: 'error',
            title: 'Impossível cadastrar itens complemento sem nome.',
          });

          hasError = true;
          return;
        }

        if (item.qtd_min > item.qtd_max) {
          addToast({
            type: 'error',
            title: 'Quantidade inválida.',
            description: `A quantidade mínima do item ${item.descricao} deve ser maior que a quantidade máxima.`,
          });

          hasError = true;
          return;
        }

        if (item.descricao) {
          const requestObj = {
            id: item.id,
            produto_id: item.materiaPrimaSelected
              ? item.materiaPrimaSelected.id
              : undefined,
            complemento_id: id_complemento,
            tipo: 1,
            codigo_complemento: item.codigo_complemento
              ? item.codigo_complemento
              : undefined,
            descricao: item.descricao,
            preco: item.preco,
            isNew: item.isNew,
            hasImage: !!item.newItemImage,
            qtd_min: item.qtd_min,
            qtd_max: item.qtd_max,
            pausar_venda: Boolean(item.pausar_venda),
            ordem: item.ordem,
          };

          requestArray.push(requestObj);
          item.newItemImage &&
            dataForm.append('item_complemento_img', item.newItemImage);
        }
      });

      if (hasError) return;

      dataForm.append('itens_complemento', JSON.stringify(requestArray));

      await api.put('/complemento/item', dataForm, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      });

      addToast({
        type: 'success',
        title: 'Complementos atualizados.',
      });

      handleSetComplementoUpdated(true);
      handleSetComplementoDrawerClosed(true);
    } catch (err) {
      const { message } = err.response.data;

      addToast({
        type: 'error',
        title: message,
      });
    }
  }, [
    itensDoMesmoComplemento,
    addToast,
    id_complemento,
    handleSetComplementoUpdated,
  ]);

  const handleDeleteItemComplemento = useCallback(
    async (item_index: number, id: number | undefined) => {
      if (qtdComplementos.length <= 1) {
        addToast({
          title: 'Opss...',
          type: 'error',
          description:
            'O complemento tem que ter pelo menos um item complemento',
        });

        const itensUpdated = [...itensDoMesmoComplemento];
        itensUpdated[item_index].modalOpen = false;

        setItensDoMesmoComplemento([...itensUpdated]);

        return;
      }

      try {
        setBtnDisable(true);
        const newItens = [...itensDoMesmoComplemento];
        const newQtd = [...qtdComplementos];
        newItens.splice(item_index, 1);
        newQtd.splice(qtdComplementos.length - 1, 1);
        if (id) {
          await api.delete(`/complemento/item/${id}`);
        }
        setBtnDisable(false);
        setQtdComplementos([...newQtd]);
        setItensDoMesmoComplemento([...newItens]);
        addToast({
          type: 'info',
          title: 'Item excluído',
        });
        handleSetComplementoUpdated(true);
      } catch (err) {
        const itensUpdated = [...itensDoMesmoComplemento];
        itensUpdated[item_index].modalOpen = false;

        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });

        setBtnDisable(false);
        setItensDoMesmoComplemento([...itensUpdated]);
      }
    },
    [
      addToast,
      qtdComplementos,
      itensDoMesmoComplemento,
      handleSetComplementoUpdated,
    ],
  );

  return (
    <TabWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.noPaddingBot}>
          <AddButton type="button" onClick={handleAddComplemento}>
            + Adicionar Complemento
          </AddButton>
        </Grid>

        <Grid item xs={12}>
          <div>
            {qtdComplementos
              .sort((a, b) => {
                if (
                  itensDoMesmoComplemento[a.index] &&
                  itensDoMesmoComplemento[b.index]
                ) {
                  return (
                    itensDoMesmoComplemento[a.index].ordem -
                    itensDoMesmoComplemento[b.index].ordem
                  );
                }

                return 300;
              })
              .map((item) => (
                <>
                  {itensDoMesmoComplemento[item.index] && (
                    <FormWrapper className="form_item" key={item.index}>
                      <Grid container spacing={3}>
                        <Grid item xs={3}>
                          <NewImg>
                            <>
                              {!itensDoMesmoComplemento[item.index].isNew && (
                                <img
                                  src={
                                    itensDoMesmoComplemento[item.index].imagem
                                      ? `${
                                          process.env.REACT_APP_SERVER_URL
                                        }/files/${
                                          itensDoMesmoComplemento[item.index]
                                            .imagem
                                        }`
                                      : no_image
                                  }
                                  alt="Item Complemento"
                                />
                              )}

                              {itensDoMesmoComplemento[item.index].isNew && (
                                <img
                                  src={
                                    itensDoMesmoComplemento[item.index]
                                      .newItemImage
                                      ? URL.createObjectURL(
                                          itensDoMesmoComplemento[item.index]
                                            .newItemImage,
                                        )
                                      : no_image
                                  }
                                  alt="Item Complemento"
                                />
                              )}

                              <label htmlFor={`complemento_img${item.index}`}>
                                <FiCamera size={20} />
                                <input
                                  type="file"
                                  id={`complemento_img${item.index}`}
                                  onChange={(
                                    e: ChangeEvent<HTMLInputElement>,
                                  ) => handleImgChange(e, item.index)}
                                />
                              </label>
                            </>
                          </NewImg>
                        </Grid>

                        <Grid item xs={9}>
                          <Grid container spacing={1}>
                            <Grid item xs={4} className={classes.noPaddingTop}>
                              <LabelWrapper>
                                <span>Nome do complemento</span>
                              </LabelWrapper>

                              <InputLogged
                                name="descricao"
                                placeholder="Digite o nome"
                                value={
                                  itensDoMesmoComplemento[item.index].descricao
                                }
                                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                  handleInputChange(e, item.index, 'descricao')
                                }
                              />
                            </Grid>

                            <Grid item xs={4} className={classes.noPaddingTop}>
                              <LabelWrapper>
                                <span>Matéria Prima</span>
                              </LabelWrapper>

                              <Select
                                value={
                                  itensDoMesmoComplemento[item.index]
                                    ?.materiaPrimaSelected
                                }
                                onChange={(value: any) =>
                                  handleChangeMateriaPrima(item.index, value)
                                }
                                name="produto_id"
                                placeholder="Matéria prima"
                                options={materiasPrimas}
                              />
                            </Grid>

                            <Grid
                              item
                              xs={3}
                              className={classes.noPaddingTop}
                              style={{ textAlign: 'center' }}
                            >
                              <LabelWrapper style={{ marginBottom: 5 }}>
                                <span>Ativo</span>
                              </LabelWrapper>
                              <StatusSaleButton
                                type="button"
                                isPaused={
                                  !itensDoMesmoComplemento[item.index]
                                    .pausar_venda
                                }
                                className="paused"
                                onClick={() =>
                                  handleActiveChange(false, item.index)
                                }
                              >
                                Não
                              </StatusSaleButton>

                              <StatusSaleButton
                                type="button"
                                isPaused={
                                  !!itensDoMesmoComplemento[item.index]
                                    .pausar_venda
                                }
                                className="activated"
                                onClick={() =>
                                  handleActiveChange(true, item.index)
                                }
                              >
                                Sim
                              </StatusSaleButton>
                            </Grid>

                            <Grid item xs={1} className={classes.noPaddingTop}>
                              <TrashBtnWrapper>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleToggleModal(item.index, true)
                                  }
                                >
                                  <FaRegTrashAlt size={20} />
                                </button>
                              </TrashBtnWrapper>

                              <Modal
                                className={modalClasses.modal}
                                open={
                                  itensDoMesmoComplemento[item.index].modalOpen
                                }
                                onClose={() =>
                                  handleToggleModal(item.index, false)
                                }
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                  timeout: 500,
                                }}
                              >
                                <Fade
                                  in={
                                    itensDoMesmoComplemento[item.index]
                                      .modalOpen
                                  }
                                >
                                  <ModalWrapper>
                                    <div className="header">
                                      <h1>Exclusão</h1>

                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleToggleModal(item.index, false)
                                        }
                                      >
                                        <RiCloseLine size={30} />
                                      </button>
                                    </div>

                                    <div className="description">
                                      <span>
                                        Deseja excluir o item{' '}
                                        {
                                          itensDoMesmoComplemento[item.index]
                                            .descricao
                                        }
                                        ?
                                      </span>
                                    </div>

                                    <div className="btnActions">
                                      <button
                                        type="button"
                                        className="confirm"
                                        disabled={btnDisable}
                                        onClick={() =>
                                          handleDeleteItemComplemento(
                                            item.index,
                                            itensDoMesmoComplemento[item.index]
                                              .id,
                                          )
                                        }
                                      >
                                        Confirmar
                                      </button>

                                      <button
                                        type="button"
                                        className="cancel"
                                        onClick={() =>
                                          handleToggleModal(item.index, false)
                                        }
                                      >
                                        Cancelar
                                      </button>
                                    </div>
                                  </ModalWrapper>
                                </Fade>
                              </Modal>
                            </Grid>

                            <Grid item xs={3} className={classes.noPaddingTop}>
                              <LabelWrapper>
                                <span>Preço</span>
                              </LabelWrapper>

                              <InputLogged
                                name="preco"
                                type="number"
                                placeholder="Preco"
                                value={
                                  itensDoMesmoComplemento[item.index].preco
                                }
                                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                  handleInputChange(e, item.index, 'preco')
                                }
                                step=".001"
                              />
                            </Grid>

                            <Grid item xs={3} className={classes.noPaddingTop}>
                              <LabelWrapper>
                                <span>Código PDV</span>
                              </LabelWrapper>

                              <InputLogged
                                name="codigo_complemento"
                                placeholder="Código"
                                value={
                                  itensDoMesmoComplemento[item.index]
                                    .codigo_complemento
                                }
                                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                  handleInputChange(
                                    e,
                                    item.index,
                                    'codigo_complemento',
                                  )
                                }
                              />
                            </Grid>

                            <Grid
                              item
                              xs={3}
                              className={classes.qtdWrapperStyle}
                            >
                              <QtdItemContainer>
                                <div className="control-wrapper">
                                  <span>Mínimo</span>

                                  <div>
                                    <button
                                      type="button"
                                      className="decrement"
                                      onClick={() =>
                                        handleSetQtd(
                                          'qtdMin',
                                          'decrement',
                                          item.index,
                                        )
                                      }
                                    >
                                      -
                                    </button>

                                    <input
                                      type="number"
                                      min="0"
                                      readOnly
                                      value={
                                        itensDoMesmoComplemento[item.index]
                                          .qtd_min
                                      }
                                    />

                                    <button
                                      type="button"
                                      className="increment"
                                      onClick={() =>
                                        handleSetQtd(
                                          'qtdMin',
                                          'increment',
                                          item.index,
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </QtdItemContainer>
                            </Grid>

                            <Grid
                              item
                              xs={3}
                              className={classes.qtdWrapperStyle}
                            >
                              <QtdItemContainer>
                                <div className="control-wrapper">
                                  <span>Máximo</span>

                                  <div>
                                    <button
                                      type="button"
                                      className="decrement"
                                      onClick={() =>
                                        handleSetQtd(
                                          'qtdMax',
                                          'decrement',
                                          item.index,
                                        )
                                      }
                                    >
                                      -
                                    </button>

                                    <input
                                      type="number"
                                      min="0"
                                      readOnly
                                      value={
                                        itensDoMesmoComplemento[item.index]
                                          .qtd_max
                                      }
                                    />

                                    <button
                                      type="button"
                                      className="increment"
                                      onClick={() =>
                                        handleSetQtd(
                                          'qtdMax',
                                          'increment',
                                          item.index,
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </QtdItemContainer>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </FormWrapper>
                  )}
                </>
              ))}

            <Grid item xs={12} className={classes.noPaddingBot}>
              <SubmitButtonWrapper>
                <ButtonAction
                  type="button"
                  className="cancel"
                  onClick={() => handleSetComplementoDrawerClosed(true)}
                >
                  Cancelar
                </ButtonAction>

                <ButtonAction
                  type="submit"
                  className="submit"
                  onClick={handleSubmit}
                >
                  Salvar
                </ButtonAction>
              </SubmitButtonWrapper>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </TabWrapper>
  );
};

export default Complementos;
